const size = [10, 15, 20, 25, 30, 35];

const SVGSize = {
  xs: { height: size[0], width: size[0], fill: "currentColor" },
  s: { height: size[1], width: size[1], fill: "currentColor" },
  m: { height: size[2], width: size[2], fill: "currentColor" },
  l: { height: size[3], width: size[3], fill: "currentColor" },
  xl: { height: size[4], width: size[4], fill: "currentColor" },
  xxl: { height: size[5], width: size[5], fill: "currentColor" },
};

export default SVGSize;
